// Must match the Android manifest default_notification_channel_id (strings.xml) so FCM-posted
// and notifee-posted notifications share one channel.
export const DEFAULT_CHANNEL_ID = 'default';
export const DEFAULT_CHANNEL_NAME = 'General';
